import { cloneDeep } from "lodash";
import { TIME_ZONES } from "../../../../../../constants";

export const ENTITY_FORM_TIME_ZONES = [
	{
		ianaCode: "",
		name: ""
	},
	...TIME_ZONES
];

export function getEntityTimeZone(timeZoneCode) {
	return ENTITY_FORM_TIME_ZONES.find(timeZone => timeZone.ianaCode === timeZoneCode);
}

export function mapEntityForForm(entity, entityManager) {
	const mappedEntity = cloneDeep(entity);

	if(mappedEntity.Classification) {
		mappedEntity.Classification = entityManager.getClassificationById(
			mappedEntity.Classification.Id
		);
	}

	return mappedEntity;
}

export function hasSystemKeyValues(entityType, entity) {
	return !entityType.IsCodeSystemManaged
		|| !!entity?.Classification
		|| !!entity?.ExternalKey;
}
